<template>
  <div fluid fill-height>
    <v-expand-x-transition>
      <landing-toolbar />
    </v-expand-x-transition>
    <v-container style="min-width: 100% !important">
      <gestion-empleados />
    </v-container>
  </div>
</template>

<script>
import LandingToolbar from "../../components/LandingToolbar/LandingToolbar.vue";
import GestionEmpleados from "../../components/GestionEmpleados/GestionEmpleados.vue";
export default {
  components: { GestionEmpleados, LandingToolbar },
};
</script>
